module.exports = __webpack_public_path__ + "media/src/images/arrow__questionBack--v2--dark-6faa41099a2dfa59c6d87093ef40f7fc.png";